export interface DeffinumStorySequencesMediasData {
  id: number;
  duration: number; // milliseconds
  media: {
    src: string;
    type: 'video' | 'image';
  };
  quizz: {
    answerId: number;
    selectedAnswerId: number;
    delayBeforeDisplay: number; // milliseconds
    question: string;
    explanation: string;
    answers: {
      id: number;
      content: string;
    }[];
  };
}
export interface DeffinumStorySequencesData {
  id: number;
  medias: DeffinumStorySequencesMediasData[];
}
export class DeffinumStoryData {
  sequences: DeffinumStorySequencesData[];

  constructor(rawData?: DeffinumStoryData) {
    this.sequences = rawData?.sequences || [];
  }
}
